
(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHeader(){
    var header=document.querySelector('[data-xfun-header]');
    if(!header||header.dataset.scrollReady==='true')return;
    header.dataset.scrollReady='true';
    var ticking=false;
    var last=null;
    function update(){
      ticking=false;
      var next=window.scrollY>20;
      if(next===last)return;
      last=next;
      header.classList.toggle('is-scrolled',next);
    }
    function requestUpdate(){
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll',requestUpdate,{passive:true});
  }

  var activeDialog=null;
  var dialogKeysBound=false;
  var focusSelector='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function makeDialog(container,dialog,bodyClass,openSelector,closeSelector,onOpen,onClose){
    if(!container||container.dataset.dialogReady==='true')return null;
    container.dataset.dialogReady='true';
    var openers=Array.from(document.querySelectorAll(openSelector));
    var inertElements=[];
    var state={container:container,dialog:dialog,trigger:null,hide:hide};

    function setBackgroundInert(){
      var current=container;
      while(current&&current!==document.body){
        var parent=current.parentElement;
        if(!parent)break;
        Array.from(parent.children).forEach(function(sibling){
          if(sibling===current||/^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName))return;
          inertElements.push({node:sibling,inert:sibling.inert});
          sibling.inert=true;
        });
        current=parent;
      }
    }

    function show(trigger){
      if(activeDialog===state)return;
      if(activeDialog){
        if(activeDialog.container.contains(trigger))trigger=activeDialog.trigger;
        activeDialog.hide(false);
      }
      state.trigger=trigger||document.activeElement;
      container.hidden=false;
      container.setAttribute('aria-hidden','false');
      openers.forEach(function(opener){opener.setAttribute('aria-expanded','true');});
      document.body.classList.add(bodyClass);
      activeDialog=state;
      setBackgroundInert();
      requestAnimationFrame(function(){
        if(activeDialog!==state)return;
        var target=dialog.querySelector('[data-xfp-search-input]')||dialog.querySelector(focusSelector);
        if(target)target.focus({preventScroll:true});
        if(onOpen)onOpen();
      });
    }

    function hide(restoreFocus){
      if(container.hidden)return;
      container.hidden=true;
      container.setAttribute('aria-hidden','true');
      openers.forEach(function(opener){opener.setAttribute('aria-expanded','false');});
      document.body.classList.remove(bodyClass);
      inertElements.forEach(function(entry){entry.node.inert=entry.inert;});
      inertElements=[];
      if(activeDialog===state)activeDialog=null;
      if(onClose)onClose();
      if(restoreFocus!==false&&state.trigger&&document.contains(state.trigger))state.trigger.focus({preventScroll:true});
    }

    openers.forEach(function(opener){opener.addEventListener('click',function(event){event.preventDefault();show(opener);});});
    container.querySelectorAll(closeSelector).forEach(function(closer){closer.addEventListener('click',function(){hide();});});

    if(!dialogKeysBound){
      dialogKeysBound=true;
      document.addEventListener('keydown',function(event){
        if(!activeDialog)return;
        if(event.key==='Escape'){
          event.preventDefault();
          event.stopPropagation();
          activeDialog.hide();
          return;
        }
        if(event.key!=='Tab')return;
        var focusable=Array.from(activeDialog.dialog.querySelectorAll(focusSelector)).filter(function(node){return node.tabIndex>=0&&!node.inert&&node.getClientRects().length>0;});
        if(!focusable.length){event.preventDefault();return;}
        var first=focusable[0];
        var last=focusable[focusable.length-1];
        if(event.shiftKey&&(document.activeElement===first||!activeDialog.dialog.contains(document.activeElement))){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&(document.activeElement===last||!activeDialog.dialog.contains(document.activeElement))){event.preventDefault();first.focus();}
      });
    }
    return state;
  }

  function initMenu(){
    var menu=document.querySelector('[data-xfp-menu]');
    if(!menu)return;
    var state=makeDialog(menu,menu,'xfp-menu-open','[data-xfp-menu-open]','[data-xfp-menu-close]');
    if(!state)return;
    menu.querySelectorAll('a:not([data-xfp-search-open])').forEach(function(link){link.addEventListener('click',function(){state.hide(false);});});
  }

  function initSearchOverlay(){
    var panel=document.querySelector('[data-xfp-search-panel]');
    if(!panel||panel.dataset.ready==='true')return;
    panel.dataset.ready='true';
    var input=panel.querySelector('[data-xfp-search-input]');
    var form=panel.querySelector('[data-xfp-search-form]');
    var clear=panel.querySelector('[data-xfp-search-clear]');
    var status=panel.querySelector('[data-xfp-search-status]');
    var defaults=panel.querySelector('[data-xfp-search-default]');
    var results=panel.querySelector('[data-xfp-search-results]');
    var timer=null;
    var requestId=0;
    var controller=null;
    var suggestionCache=new Map();
    var connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
    var slowConnection=!!(connection&&(connection.saveData||/^(slow-2g|2g|3g)$/.test(connection.effectiveType)));
    var debounceDelay=slowConnection?360:220;
    var currency=panel.dataset.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
    var priceFormatter=null;
    if(currency){
      try{priceFormatter=new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:currency,trailingZeroDisplay:'stripIfInteger'});}catch(error){}
    }

    function setStatus(message){if(status)status.textContent=message||'';}
    function productPrice(item){
      if(!priceFormatter)return '';
      var rawMin=item.price_min==null||item.price_min===''?item.price:item.price_min;
      if(rawMin==null||rawMin==='')return '';
      var minimum=Number(rawMin);
      var maximum=Number(item.price_max==null||item.price_max===''?rawMin:item.price_max);
      if(!Number.isFinite(minimum)||minimum<0)return '';
      var formatted=priceFormatter.format(minimum);
      return Number.isFinite(maximum)&&maximum>minimum?formatted+' – '+priceFormatter.format(maximum):formatted;
    }
    function resetResults(){
      if(defaults)defaults.hidden=false;
      if(results){results.hidden=true;results.setAttribute('aria-busy','false');results.replaceChildren();}
      setStatus('');
    }
    function appendAll(query){
      var all=document.createElement('a');
      var url=new URL(form.action,window.location.origin);
      url.searchParams.set('q',query);
      url.searchParams.set('options[prefix]','last');
      all.href=url.toString();all.className='xfe-search__all';all.textContent=panel.dataset.viewAllText;
      results.appendChild(all);
    }
    function addGroup(parent,title,items,products){
      if(!items||!items.length)return;
      var group=document.createElement('div');
      var showImages=products&&!slowConnection;
      group.className='xfp-search-panel__result-group '+(products?'xfe-search__result-group--products':'xfe-search__result-group--collections')+(products&&!showImages?' is-text-only':'');
      var heading=document.createElement('p');heading.className='xfp-search-panel__eyebrow';heading.textContent=title;group.appendChild(heading);
      var list=document.createElement('div');list.className='xfe-search__result-items';
      items.slice(0,4).forEach(function(item){
        if(!item.url)return;
        var link=document.createElement('a');link.href=item.url;link.className='xfp-search-panel__result-link';
        var imageUrl=item.image&&(item.image.url||item.image.src||item.image);
        if(showImages&&typeof imageUrl==='string'&&imageUrl){
          var picture=document.createElement('img');
          try{var smallImage=new URL(imageUrl,window.location.origin);smallImage.searchParams.set('width','360');picture.src=smallImage.toString();}catch(error){picture.src=imageUrl;}
          picture.alt='';picture.width=240;picture.height=240;picture.loading='lazy';picture.decoding='async';picture.className='xfp-search-panel__result-image';link.appendChild(picture);
        }
        var details=document.createElement('span');details.className='xfe-search__result-details';
        var name=document.createElement('span');name.textContent=item.title||'';details.appendChild(name);
        if(products){
          var priceText=productPrice(item);
          if(priceText){var price=document.createElement('span');price.className='xfe-search__result-price';price.textContent=priceText;details.appendChild(price);}
        }
        link.appendChild(details);list.appendChild(link);
      });
      group.appendChild(list);parent.appendChild(group);
    }
    function renderSuggestions(data,query){
      if(!results)return;
      var resources=data&&data.resources&&data.resources.results?data.resources.results:{};
      var products=resources.products||[];var collections=resources.collections||[];
      results.replaceChildren();
      if(!products.length&&!collections.length){
        var empty=document.createElement('p');empty.className='xfp-search-panel__empty';empty.textContent=panel.dataset.emptyText;results.appendChild(empty);
      }else{
        var grid=document.createElement('div');grid.className='xfp-search-panel__results-grid';
        addGroup(grid,panel.dataset.productsText,products,true);addGroup(grid,panel.dataset.collectionsText,collections,false);results.appendChild(grid);
      }
      appendAll(query);
      if(defaults)defaults.hidden=true;
      results.hidden=false;results.setAttribute('aria-busy','false');setStatus('');
    }
    function cachedSuggestions(query){
      var entry=suggestionCache.get(query);
      if(!entry)return null;
      if(Date.now()-entry.time>=60000){suggestionCache.delete(query);return null;}
      return entry.data;
    }
    function cacheSuggestions(query,data){
      suggestionCache.delete(query);
      suggestionCache.set(query,{data:data,time:Date.now()});
      while(suggestionCache.size>20)suggestionCache.delete(suggestionCache.keys().next().value);
    }
    function fetchSuggestions(query){
      if(!form)return;
      var current=++requestId;if(controller)controller.abort();controller=null;
      var cached=cachedSuggestions(query);
      if(cached){renderSuggestions(cached,query);return;}
      var url=new URL(form.getAttribute('action')||'/search',window.location.origin);
      url.pathname=url.pathname.replace(/\/search\/?$/,'/search/suggest.json');url.searchParams.set('q',query);url.searchParams.set('resources[type]','product,collection');url.searchParams.set('resources[limit]','4');
      controller=('AbortController' in window)?new AbortController():null;
      var options={headers:{Accept:'application/json'}};if(controller)options.signal=controller.signal;
      if(results)results.setAttribute('aria-busy','true');setStatus(panel.dataset.loadingText);
      fetch(url.toString(),options)
        .then(function(response){if(!response.ok)throw new Error('search');return response.json();})
        .then(function(data){if(current===requestId){cacheSuggestions(query,data);renderSuggestions(data,query);}})
        .catch(function(error){
          if(error&&error.name==='AbortError')return;
          if(current!==requestId)return;
          if(defaults)defaults.hidden=true;
          if(results){results.replaceChildren();appendAll(query);results.hidden=false;results.setAttribute('aria-busy','false');}
          setStatus(panel.dataset.errorText);
        });
    }
    function handleInput(){
      var query=input.value.trim();if(clear)clear.hidden=!input.value;
      clearTimeout(timer);requestId++;if(controller)controller.abort();
      if(query.length<2){resetResults();return;}
      if(cachedSuggestions(query)){fetchSuggestions(query);return;}
      setStatus(panel.dataset.loadingText);
      timer=setTimeout(function(){fetchSuggestions(query);},debounceDelay);
    }
    makeDialog(panel,panel.querySelector('[role="dialog"]'),'xfp-search-open','[data-xfp-search-open]','[data-xfp-search-close]',function(){
      if(clear)clear.hidden=!input.value;
      if(input&&input.value.trim().length>=2)fetchSuggestions(input.value.trim());
    },function(){clearTimeout(timer);requestId++;if(controller)controller.abort();if(results)results.setAttribute('aria-busy','false');setStatus('');});
    if(input)input.addEventListener('input',handleInput);
    if(clear)clear.addEventListener('click',function(){input.value='';handleInput();input.focus({preventScroll:true});});
  }

  function initLocalizationFooter(){
    var modal=document.querySelector('[data-xfp-localization-modal]');
    if(!modal)return;
    var state=makeDialog(modal,modal.querySelector('[role="dialog"]'),'xfp-localization-open','[data-xfp-localization-open]','[data-xfp-localization-close]');
    if(!state)return;
    var form=modal.querySelector('.xfp-localization-form');
    var submit=modal.querySelector('[data-xfp-localization-submit]');
    if(form)form.addEventListener('submit',function(){if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}});
  }

  function initCartCounts(){
    if(document.documentElement.dataset.xfunCartCountsReady)return;
    document.documentElement.dataset.xfunCartCountsReady='true';
    var version=0;
    var timer=null;
    function update(count){
      if(typeof count!=='number'||!Number.isFinite(count))return;
      document.querySelectorAll('[data-xfun-cart-count]').forEach(function(badge){badge.textContent=String(count);badge.hidden=count===0;});
    }
    function refresh(){
      var current=++version;
      var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
      fetch(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
        .then(function(response){if(!response.ok)throw new Error('cart');return response.json();})
        .then(function(cart){if(current===version)update(cart.item_count);})
        .catch(function(){});
    }
    function onCartChange(event){
      var response=event.detail&&event.detail.response;
      clearTimeout(timer);
      if(response&&typeof response.item_count==='number'){version++;update(response.item_count);return;}
      var countHTML=response&&response.sections&&response.sections['cart-item-count'];
      if(countHTML){
        var countDocument=new DOMParser().parseFromString(countHTML,'text/html');
        var count=parseInt(countDocument.body.textContent.trim(),10);
        if(Number.isFinite(count)){version++;update(count);return;}
      }
      timer=setTimeout(refresh,80);
    }
    ['shapes:cart:afteradditem','shapes:cart:cartqtychange','shapes:cart:update'].forEach(function(name){window.addEventListener(name,onCartChange);});
    window.addEventListener('pageshow',function(event){if(event.persisted)refresh();});
  }

  function initDualCampaignHero(){
    var root=document.querySelector('[data-xfc-dual-hero]');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';

    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-xfc-dual-slide]'));
    var dots=Array.prototype.slice.call(root.querySelectorAll('[data-xfc-dual-dot]'));
    var mobileDots=Array.prototype.slice.call(root.querySelectorAll('[data-xfc-dual-mobile-dot]'));
    var prev=root.querySelector('[data-xfc-dual-prev]');
    var next=root.querySelector('[data-xfc-dual-next]');
    var progress=root.querySelector('[data-xfc-dual-progress]');
    if(slides.length<2)return;

    var interval=Number(root.getAttribute('data-interval'))||5600;
    var connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
    var lowBandwidth=document.documentElement.classList.contains('xfun-low-bandwidth')||!!(connection&&connection.saveData);
    var current=0;
    var timer=null;
    var touchX=null;
    var touchY=null;

    function restartProgress(){
      if(!progress)return;
      progress.classList.remove('is-running');
      void progress.offsetWidth;
      if(!reduced.matches)progress.classList.add('is-running');
    }

    function show(index,manual){
      current=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        var active=i===current;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===current);});
      mobileDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===current);});
      restartProgress();
      if(manual)restartTimer();
    }

    function restartTimer(){
      clearInterval(timer);
      if(reduced.matches||lowBandwidth)return;
      timer=setInterval(function(){show(current+1,false);},interval);
    }

    if(prev)prev.addEventListener('click',function(){show(current-1,true);});
    if(next)next.addEventListener('click',function(){show(current+1,true);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){show(Number(dot.getAttribute('data-index'))||0,true);});
    });

    root.addEventListener('touchstart',function(event){
      var touch=event.changedTouches&&event.changedTouches[0];
      if(!touch)return;
      touchX=touch.clientX;
      touchY=touch.clientY;
    },{passive:true});

    root.addEventListener('touchend',function(event){
      if(touchX===null||touchY===null)return;
      var touch=event.changedTouches&&event.changedTouches[0];
      if(!touch)return;
      var dx=touch.clientX-touchX;
      var dy=touch.clientY-touchY;
      touchX=null;touchY=null;
      if(Math.abs(dx)>48&&Math.abs(dx)>Math.abs(dy)*1.25){
        show(dx<0?current+1:current-1,true);
      }
    },{passive:true});

    document.addEventListener('visibilitychange',function(){
      if(document.hidden)clearInterval(timer);
      else restartTimer();
    });

    show(0,false);
    restartTimer();
  }

  function initTabs(){
    document.querySelectorAll('[data-xfp-tabs]').forEach(function(root){
      if(root.dataset.ready==='true')return;
      root.dataset.ready='true';
      var buttons=Array.prototype.slice.call(root.querySelectorAll('[data-xfp-tab]'));
      var panels=Array.prototype.slice.call(root.querySelectorAll('[data-xfp-panel]'));
      buttons.forEach(function(button){
        button.addEventListener('click',function(){
          var target=button.getAttribute('data-xfp-tab');
          buttons.forEach(function(b){b.classList.toggle('is-active',b===button);});
          panels.forEach(function(panel){
            var active=panel.getAttribute('data-xfp-panel')===target;
            panel.hidden=!active;
            panel.classList.toggle('is-active',active);
          });
        });
      });
    });
  }

  function initLazyVideos(){
    var videos=Array.prototype.slice.call(document.querySelectorAll('[data-xfun-video]'));
    if(!videos.length)return;
    function load(video){
      if(video.dataset.loaded)return;
      var src=video.getAttribute('data-src');
      if(!src)return;
      var source=document.createElement('source');
      source.src=src;
      source.type='video/mp4';
      video.appendChild(source);
      video.dataset.loaded='true';
      video.load();
    }
    if(!('IntersectionObserver' in window)){
      videos.forEach(function(video){load(video);if(!reduced.matches)video.play().catch(function(){});});
      return;
    }
    var lowBandwidth=document.documentElement.classList.contains('xfun-low-bandwidth');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video=entry.target;
        if(entry.isIntersecting){
          load(video);
          if(!reduced.matches)video.play().catch(function(){});
        }else{
          video.pause();
        }
      });
    },{rootMargin:lowBandwidth?'64px 0px':'240px 0px',threshold:.08});
    videos.forEach(function(video){observer.observe(video);});
  }

  function cleanMoneyText(root){
    var target=root||document.getElementById('MainContent')||document.body;
    if(!target)return;
    var walker=document.createTreeWalker(target,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      var value=node.nodeValue;
      if(!value||(value.indexOf('.00')===-1&&value.indexOf(',00')===-1))continue;
      var cleaned=value.replace(/([0-9])(?:[.,]00)(?=\s*(?:€|EUR)|$)/g,'$1');
      if(cleaned!==value)node.nodeValue=cleaned;
    }
  }

  function initMoneyCleaner(){
    cleanMoneyText();
    var main=document.getElementById('MainContent');
    if(!main||!window.MutationObserver)return;
    var pending=[];
    var raf=null;
    function flush(){
      raf=null;
      var nodes=pending.splice(0,pending.length);
      nodes.forEach(function(node){
        if(!node)return;
        if(node.nodeType===Node.TEXT_NODE){
          var value=node.nodeValue||'';
          if(value.indexOf('.00')===-1&&value.indexOf(',00')===-1)return;
          var cleaned=value.replace(/([0-9])(?:[.,]00)(?=\s*(?:€|EUR)|$)/g,'$1');
          if(cleaned!==value)node.nodeValue=cleaned;
          return;
        }
        if(node.nodeType===Node.ELEMENT_NODE)cleanMoneyText(node);
      });
    }
    new MutationObserver(function(records){
      records.forEach(function(record){
        if(record.type==='characterData')pending.push(record.target);
        record.addedNodes&&record.addedNodes.forEach(function(node){pending.push(node);});
      });
      if(!raf&&pending.length)raf=requestAnimationFrame(flush);
    }).observe(main,{subtree:true,childList:true,characterData:true});
  }

  function boot(){
    initHeader();
    initCartCounts();
    initMenu();
    initSearchOverlay();
    initLocalizationFooter();
    initDualCampaignHero();
    initTabs();
    initLazyVideos();
    initMoneyCleaner();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  document.addEventListener('shopify:section:load',function(){initLocalizationFooter();initDualCampaignHero();initTabs();initLazyVideos();});
})();

